/**
 * Created by tatekim on 2017. 2. 2..
 */
(function() {
    'use strict';
    var app = angular.module('admin');

    app.factory('authInterceptor', function($window, $q, $injector, $rootScope) {
        var interceptor = {};
        var refreshTokenPromise = null;

        function refreshToken() {
            if (refreshTokenPromise != null) {
                console.log('has refresh promise');
                return refreshTokenPromise;
            }
            var $http = $injector.get('$http');
            var vv = $injector.get('vv');
            var useSecure = vv.getVvMetaData('use_secure');
            var hostname = useSecure ? ('https://' + $window.location.hostname) : '';

            refreshTokenPromise = $http.post(hostname + '/admin/data/auth/refresh', {
            }, {withCredentials: true, refreshingToken:true}).catch(function(resp) {
                console.log('refresh failed');
                return $q.reject('refresh_failed')
            }).finally(function() {
                refreshTokenPromise = null;
            });

            return refreshTokenPromise;
        }

        interceptor.responseError = function(response) {
            if (response.status == 401
                    && !response.config.refreshingToken
                    && !response.config.url.match(/^\/admin\/data\/auth/)
                    && !response.config.url.match(/^https?:\/\/[^\/]+\/admin\/data\/auth/)) {
                return refreshToken().then(function() {
                    var $http = $injector.get('$http');
                    return $http(response.config);
                }, function() {
                    $rootScope.user = null;
                    return $q.reject(response);
                });
            }
            return $q.reject(response);
        };

        return interceptor;
    });

    app.factory('hashInterceptor', function(vv) {
        var interceptor = {};

        var staticRoot = vv.getVvMetaData('static_root');
        if (staticRoot) {
            interceptor.request = function(config) {
                if (config.url.indexOf('/') == 0 && (
                    config.url.indexOf('?_hv=') > 0 || config.url.match(/\.(html)$/)
                    ))
                    config.url = staticRoot + config.url;

                return config;
            };
        }

        return interceptor;
    });

    app.config(function($httpProvider) {
        $httpProvider.interceptors.push('hashInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
    });

    app.config(['plUploadServiceProvider', function(plUploadServiceProvider) {
        plUploadServiceProvider.setConfig('flashPath', '/js/plupload-angular-direective/plupload.flash.swf');
        plUploadServiceProvider.setConfig('silverLightPath', '/js/plupload-angular-direective/plupload.silverlight.xap');
    }]);

    app.config(function (minicolorsProvider) {
        angular.extend(minicolorsProvider.defaults, {
            control: 'hue',
            position: 'bottom left',
            theme: 'bootstrap'
        });
    });

    app.config(['$httpProvider', 'vvBrowser', function($httpProvider, vvBrowser) {
        //$httpProvider.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
        // disable IE ajax request caching
        if (vvBrowser.isIe()) {
            $httpProvider.defaults.headers.post['If-Modified-Since'] = 'Wed, 19 Oct 2005 10:50:00 GMT';
        }
    }]);

})();
